import { UserRole } from '@/lib/types';

export type TRoute = {
  href: ERoute | ERouteAction;
  permission: UserRole[];
  parentHref?: ERoute;
};

export enum ERoute {
  DASHBOARD = 'dashboard',
  ACCOUNT = 'account',
  PROFILE = 'profile',
  PAYMENT_HISTORY = 'paymenthistory',
  SETTINGS = 'settingspreferences',
  ANIMALS = 'animals',
  MEMBERS = 'members',
  RULES = 'rules',
  ADD_ANIMAL = 'addanimal',
  RESTRICTED = 'restricted',
  ORGANISATION = 'organisation',
  ADD_ORG_TRAIT = 'addorganisationtrait',
  CONFIG = 'config',
  BECOME_MEMBER = 'becomemember',
  ADD_MEMBER = 'add-member/details',
  BUILDER = 'builder',
  FINISH_ACCOUNT = 'finish-account-setup',
  FIELDS_CONFIG = 'fields',
  FORMS_MANAGER = 'forms',
  TRANSFERS = 'transfers',
  IMPORTS = 'imports',
  CERTIFICATE_TEMPLATES = 'certificates',
  USER_ASSIGNMENTS = 'user-assignments',
}

export const APP_ROUTE_NAMES = {
  HOME: 'Home',
  SEARCH: 'Database Search',
  REGISTRY: 'Registry',
};

export const PUBLIC_ROUTES = {
  HOME: '/',
  /** Org-picker landing (public marketing header). */
  SEARCH: '/search',
  ACCEPT_INVITE: '/accept-invite',
  HEALTHZ: '/healthz',
  LOGOUT: '/logout',
  RESTRICTED: '/restricted',
  SUPPORT: '/support',
  TERMS: '/terms',
  PRIVACY: '/privacy',
  /** Society public animal search + detail: `/{societyCode}/animals`. */
  ANIMAL: '/animals',
  /** Society public member search + detail: `/{societyCode}/members`. */
  MEMBER: '/members',
  REGISTRY_LANDING: '/registry',
};

export const APP_ROUTE_PATHS = {
  DASHBOARD: `/${ERoute.DASHBOARD}`,
  FORMS_MANANGER: `/${ERoute.CONFIG}/${ERoute.FORMS_MANAGER}`,
  CREATE_FORM: `/${ERoute.CONFIG}/${ERoute.FORMS_MANAGER}/create`,
  FIELDS_CONFIG: `/${ERoute.CONFIG}/${ERoute.FIELDS_CONFIG}`,
  ANIMALS: `/${ERoute.ANIMALS}`,
  IMPORTS: `/${ERoute.IMPORTS}`,
  MEMBERS: `/${ERoute.MEMBERS}`,
  RULES: `/${ERoute.CONFIG}/${ERoute.RULES}`,
  RULE_TEST_RUNNER: `/${ERoute.CONFIG}/${ERoute.RULES}/test-runner`,
  CREATE_ANIMAL: `/${ERoute.ANIMALS}/create`,
  CREATE_MEMBER: `/${ERoute.MEMBERS}/create`,
  ADD_MEMBER: `/${ERoute.MEMBERS}/${ERoute.ADD_MEMBER}`,
  TRANSFERS: `/${ERoute.ANIMALS}/${ERoute.TRANSFERS}`,
  CERTIFICATE_TEMPLATES: `/${ERoute.CONFIG}/${ERoute.CERTIFICATE_TEMPLATES}`,
  USER_ASSIGNMENTS: `/${ERoute.USER_ASSIGNMENTS}`,
};

export enum ERouteAction {
  VIEW = 'view',
  SELECT = 'select',
  REVIEW = 'review',
}

const allPermissions = [UserRole.Admin, UserRole.Breeder];

export const routes: Array<TRoute> = [
  {
    href: ERoute.RESTRICTED,
    permission: allPermissions,
  },
  {
    href: ERoute.ACCOUNT,
    permission: allPermissions,
  },
  {
    href: ERoute.PROFILE,
    parentHref: ERoute.ACCOUNT,
    permission: allPermissions,
  },
  {
    href: ERoute.PAYMENT_HISTORY,
    parentHref: ERoute.ACCOUNT,
    permission: allPermissions,
  },
  {
    href: ERoute.SETTINGS,
    parentHref: ERoute.ACCOUNT,
    permission: allPermissions,
  },
  {
    href: ERoute.ANIMALS,
    permission: allPermissions,
  },
  {
    href: ERoute.MEMBERS,
    permission: allPermissions,
  },
  {
    href: ERoute.ADD_ANIMAL,
    permission: allPermissions,
  },
  {
    href: ERoute.ORGANISATION,
    permission: allPermissions,
  },
  {
    href: ERoute.ADD_ORG_TRAIT,
    permission: allPermissions,
  },
  {
    href: ERoute.CONFIG,
    parentHref: ERoute.ORGANISATION,
    permission: [UserRole.Admin],
  },
  {
    href: ERoute.BECOME_MEMBER,
    permission: allPermissions,
  },
  {
    href: ERoute.BUILDER,
    permission: allPermissions,
  },
  {
    href: ERoute.FINISH_ACCOUNT,
    permission: allPermissions,
  },
];
